import api from './api';

const API_PREFIX = '/device';

const getDevice = ({ deviceId, customerEnvId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${deviceId}`);

const getDevicesLogs = ({ deviceId, page, limit, query }) =>
  api.get(`${API_PREFIX}/${deviceId}/logFiles${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getDevicesLogFile = ({ deviceId, type, filename }) =>
  api.get(`${API_PREFIX}/${deviceId}/logFile/${type}/${filename}`);

const DeviceService = {
  getDevice,
  getDevicesLogs,
  getDevicesLogFile,
};

export default DeviceService;
